import React from "react";
import { Box, Flex, keyframes } from "@chakra-ui/react";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(0.95); }
`;

const Loading = () => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      minHeight="200px"
      background="transparent"
      color="white"
      margin="0"
    >
      {/* Modern spinner with gradient */}
      <Box
        position="relative"
        width="50px"
        height="50px"
      >
        {/* Outer ring */}
        <Box
          position="absolute"
          width="50px"
          height="50px"
          borderRadius="50%"
          border="3px solid transparent"
          borderTopColor="#8b5cf6"
          borderRightColor="#06b6d4"
          animation={`${spin} 1s linear infinite`}
        />
        {/* Inner ring */}
        <Box
          position="absolute"
          top="8px"
          left="8px"
          width="34px"
          height="34px"
          borderRadius="50%"
          border="3px solid transparent"
          borderTopColor="#a855f7"
          borderLeftColor="#14b8a6"
          animation={`${spin} 0.8s linear infinite reverse`}
        />
        {/* Center dot */}
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="8px"
          height="8px"
          borderRadius="50%"
          bg="linear-gradient(135deg, #8b5cf6, #06b6d4)"
          animation={`${pulse} 1s ease-in-out infinite`}
        />
      </Box>
    </Flex>
  );
};

export default Loading;
